export const pricingURL = `${window.location.origin}/#pricing`;
export const notFound404URL = `${window.location.origin}/404`;
export const createGpxURL = `${window.location.origin}/create_gpx_track`;
export const racePlansURL = `${window.location.origin}/trail_ultra_running_race_plans`;
export const guideHowtosURL = `${window.location.origin}/trail_ultra_guides`;
export const gettingStartedURL = `${window.location.origin}/Getting_Started_Planning_first_Trail_running_activity`;
export const profileURL = `${window.location.origin}/profile`;
export const upgradeURL = `/profile#v-pills-subscription`;
export const loginURL = `${window.location.origin}/login?next=${window.location.href}`;
export const loginURLnoOrigin = `/login`;
export const logoutURL = `${window.location.origin}/logout`;
export const registerURL = `${window.location.origin}/register?next=${window.location.href}`;
export const registerURLnoOrigin = `/register`;
export const logoURL = `${window.location.origin}/static/images/waldup_logo_blue.svg`;
export const aboutURL = `${window.location.origin}/about`;
export const tcURL = `${window.location.origin}/terms_conditions#terms-of-use`;
export const ppURL = `${window.location.origin}/terms_conditions#privacy-policy`;
export const dsURL = `${window.location.origin}/terms_conditions#disclaimer`;
export const trailUltraGuidesURL = `${window.location.origin}/trail_ultra_guides`;
export const trailUltraRacePlansURL = `${window.location.origin}/trail_ultra_running_race_plans`;
export const supportURL = `${window.location.origin}/support`;
export const emailURL = `${window.location.origin}/static/images/sc-email-waldup.svg`;
export const fblogoURL = `${window.location.origin}/static/images/sc-fb-waldup.svg`;
export const instalogoURL = `${window.location.origin}/static/images/sc-insta-waldup.svg`;
export const twitterlogoURL = `${window.location.origin}/static/images/sc-twitter-waldup.svg`;